import React, { useState } from 'react'
import { Paper, IconButton } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Search } from '@mui/icons-material'
const SearchBar = () => {
  const [searchTerm, setSearchTerm] = useState("")
  // This is used for redirectation
  const navigate = useNavigate()

  const onHandleSubmit = (e) => {
    e.preventDefault();

    if (searchTerm) {
      // Go trhough the Search Feed 
      navigate(`/search/${searchTerm}`);
      setSearchTerm(""); 
    }
  }

  return (
    <>
        <Paper 
          component='form'
          sx={{
            borderRadius: 20,
            border: '1px solid white',
            pl: 2,
            my: 3,
            boxShadow: 'none',
            mr: {sm: 5},
            display: {sm: 'flex'}
          }}
          onSubmit={e => onHandleSubmit(e)}
        >
          <input 
            className='search-bar'
            value={searchTerm}
            type="text" 
            onChange={(e) => setSearchTerm(e.target.value)}
            />
          <IconButton>
            <Search/>   
          </IconButton>
        </Paper>
    </>
  )
}

export default SearchBar;